import { MemberErasurePreviewResponse } from "../contracts/MemberErasurePreviewResponse";
import { MemberErasureResponse } from "../contracts/MemberErasureResponse";
import { KeptTrainingRecord, MemberErasureResult } from "../models/MemberErasure";

/** The records an erasure would keep; an absent list reads as none. */
export const toKeptTrainingRecords = (
  response: MemberErasurePreviewResponse | null | undefined
): KeptTrainingRecord[] =>
  (response?.trainingRecordsKept ?? []).map((record) => ({
    programmeName: record.programmeName,
    heldUntil: record.heldUntil,
  }));

/** The erasure outcome; an empty body (nothing kept) reads as no hold date. */
export const toMemberErasureResult = (
  memberId: string,
  response: MemberErasureResponse | null | undefined
): MemberErasureResult => ({
  memberId,
  heldEnrolments: response?.trainingLegalHold?.heldEnrolments ?? 0,
  heldUntil: response?.trainingLegalHold?.heldUntil ?? null,
});
